import { SEND_FEEDBACK, SEND_FEEDBACK_ERROR } from './types';

let initialState = {
  feedback: {
    name: '',
    email: '',
    message: '',
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SEND_FEEDBACK:
      return {
        ...state,
        feedback: action.payload,
      };
    case SEND_FEEDBACK_ERROR:
      return {
        ...state,
        feedback: state.feedback,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/feedback/reducer.js